import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { SavePartyInput_InputAdapter_instance74xvg8u3smu5 as SavePartyInput_InputAdapter_instance } from '../type/adapter/SavePartyInput_InputAdapter.mjs';
import { obj2vqjd1bjrpmyg as obj } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var SavePartyMutation_VariablesAdapterClass;
function SavePartyMutation_VariablesAdapter() {
  if (SavePartyMutation_VariablesAdapterClass === VOID) {
    class $ {
      w6g(writer, value, customScalarAdapters, withDefaultValues) {
        writer.k4a('input');
        obj(SavePartyInput_InputAdapter_instance).t3x(writer, customScalarAdapters, value.v6g_1);
      }
    }
    initMetadataForObject($, 'SavePartyMutation_VariablesAdapter');
    SavePartyMutation_VariablesAdapterClass = $;
  }
  return SavePartyMutation_VariablesAdapterClass;
}
var SavePartyMutation_VariablesAdapter_instance;
function SavePartyMutation_VariablesAdapter_getInstance() {
  return SavePartyMutation_VariablesAdapter_instance;
}
//region block: init
SavePartyMutation_VariablesAdapter_instance = new (SavePartyMutation_VariablesAdapter())();
//endregion
//region block: exports
export {
  SavePartyMutation_VariablesAdapter_instance as SavePartyMutation_VariablesAdapter_instance3vyx4zhot72ia,
};
//endregion

//# sourceMappingURL=SavePartyMutation_VariablesAdapter.mjs.map
